import Card from "../../../../components/card";
import { DivH } from "../../../../components/divh/styled";
import IndicatorPercentValue from "../../../../components/indicator-percent-value";
import MoneySymbol from "../../../../components/money-symbol";

export interface Paran {
  title: string;
  percent?: number;
  value: number;
}

const CardPercentValue: React.FC<Paran> = ({title, value, percent}) => {
  return (
    <Card>
      <DivH>
        <IndicatorPercentValue percent={percent} />
        <div>
          <h4>{title}</h4> 
          <h3><MoneySymbol value={value} /></h3>
        </div>
      </DivH>
    </Card>
  )
};

export default CardPercentValue;
